export default __webpack_public_path__ + "static/media/Lojas.1c5083c5.svg";